/* Fuzance · panier : tiroir latéral, page Panier, ajout depuis la fiche produit.
   Contrat (voir THEME_CONVENTIONS.md, section 7) :
   - formulaire d'ajout : form[data-fz-product-form] avec input[name="id"], input[name="quantity"], bouton [data-fz-atc] et conteneur [data-fz-form-error] ;
   - lien panier de l'en-tête : [data-fz-cart-toggle] ; pastille : [data-cart-count] et [data-cart-sr] ;
   - API : FZ.cart.open(), FZ.cart.close(), FZ.cart.refresh(), FZ.cart.add(), FZ.cart.change(), FZ.cart.update() ;
   - événement : « fz:cart:updated » sur document (détail : le panier, tel que renvoyé par /cart.js).
   Éléments personnalisés (fz-cart-drawer, fz-cart-page) : ils survivent au rechargement d'une section dans l'éditeur de thème. */
(function () {
  'use strict';
  var FZ = window.FZ = window.FZ || {};
  var cart = FZ.cart = FZ.cart || {};
  if (cart.__ready) return;
  cart.__ready = true;
  cart.type = cart.type === 'page' ? 'page' : 'drawer';
  cart.openOnAdd = cart.openOnAdd !== false;
  cart.maxQty = Number(cart.maxQty) || 9;

  /* ---------- Utilitaires ---------- */
  var R = FZ.routes || {};
  var routes = {
    cart: R.cart || '/cart', add: R.cartAdd || '/cart/add.js', change: R.cartChange || '/cart/change.js',
    update: R.cartUpdate || '/cart/update.js', json: R.cartJson || '/cart.js'
  };
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function reduced() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function parseHtml(html) { return new DOMParser().parseFromString(html || '', 'text/html'); }
  function drawerEl() { return qs('fz-cart-drawer'); }
  function pageEl() { return qs('fz-cart-page'); }
  function plural(n, a, b) { return n + ' ' + (n > 1 ? b : a); }
  var JSON_HEADERS = { 'Content-Type': 'application/json' };

  /* ---------- Réseau : file d'attente, erreurs lisibles ---------- */
  var chain = Promise.resolve(), pending = 0, busyTimer = null;
  function setBusy(on) {
    clearTimeout(busyTimer);
    var apply = function () { [drawerEl(), pageEl()].forEach(function (v) { if (v && v.setBusy) v.setBusy(on); }); };
    if (on) busyTimer = setTimeout(apply, 140); else apply();
  }
  function enqueue(fn) {
    pending++; setBusy(true);
    var p = chain.then(fn);
    chain = p.then(function () {}, function () {});
    return p.then(function (v) { pending--; if (!pending) setBusy(false); return v; },
      function (e) { pending--; if (!pending) setBusy(false); throw e; });
  }
  function request(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({ 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, opts.headers || {});
    return fetch(url, opts).then(function (res) {
      return res.text().then(function (t) {
        var j = null; try { j = t ? JSON.parse(t) : null; } catch (e) { j = null; }
        if (!res.ok || (j && j.status >= 400 && (j.description || j.message))) {
          var err = new Error('cart'); err.status = res.status; err.data = j; throw err;
        }
        return j;
      });
    });
  }
  cart.errorMessage = function (err) {
    var d = err && err.data;
    if (d && d.description) return String(d.description);
    if (d && d.message && d.message !== 'Cart Error') return String(d.message);
    if (err && err.status) return 'Impossible de mettre à jour le panier pour le moment. Réessayez dans un instant.';
    return 'Connexion impossible. Vérifiez votre réseau, puis réessayez.';
  };
  function sectionsParam() { return (drawerEl() ? 'cart-drawer,' : '') + 'cart-icon-bubble'; }

  /* Pastille du panier (section cart-icon-bubble) */
  function updateBadge(html) {
    if (!html) return;
    var doc = parseHtml(html), cnt = qs('[data-cart-count]', doc), sr = qs('[data-cart-sr]', doc);
    var n = cnt ? (Number(cnt.textContent) || 0) : 0;
    qsa('[data-cart-count]').forEach(function (el) {
      var prev = Number(el.textContent) || 0;
      el.textContent = String(n); el.hidden = n === 0;
      if (n > prev && !reduced()) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
    qsa('[data-cart-sr]').forEach(function (el) { if (sr) el.textContent = sr.textContent; });
  }

  /* Applique la réponse d'une modification du panier : sections, puis événement */
  function commit(res, opts) {
    opts = opts || {};
    if (opts.silent) return Promise.resolve(res);
    var last = pending <= 1;
    if (last && res && res.sections) {
      updateBadge(res.sections['cart-icon-bubble']);
      var d = drawerEl();
      if (d && res.sections['cart-drawer']) d.renderHtml(res.sections['cart-drawer']);
    }
    var p = pageEl(), done = (last && p) ? p.refresh() : Promise.resolve();
    return done.then(function () {
      return (res && res.items && res.item_count !== undefined) ? res : request(routes.json + '?_=' + Date.now(), { cache: 'no-store' });
    }).then(function (c) {
      if (last) document.dispatchEvent(new CustomEvent('fz:cart:updated', { detail: c }));
      return c;
    });
  }

  /* ---------- API publique ---------- */
  cart.get = function () { return request(routes.json + '?_=' + Date.now(), { cache: 'no-store' }); };
  cart.add = function (data, opts) {
    var body, headers = {};
    if (typeof FormData !== 'undefined' && data instanceof FormData) {
      body = data; body.set('sections', sectionsParam()); body.set('sections_url', location.pathname);
    } else {
      body = JSON.stringify(Object.assign({}, data, { sections: sectionsParam(), sections_url: location.pathname })); headers = JSON_HEADERS;
    }
    return enqueue(function () {
      return request(routes.add, { method: 'POST', body: body, headers: headers }).then(function (res) { return commit(res, opts).then(function (c) { return { item: res, cart: c }; }); });
    });
  };
  cart.change = function (o, opts) {
    var body = { quantity: o.quantity, sections: sectionsParam(), sections_url: location.pathname };
    if (o.id) body.id = o.id; else body.line = o.line;
    return enqueue(function () {
      return request(routes.change, { method: 'POST', body: JSON.stringify(body), headers: JSON_HEADERS }).then(function (res) { return commit(res, opts); });
    });
  };
  cart.update = function (o, opts) {
    var body = Object.assign({}, o, { sections: sectionsParam(), sections_url: location.pathname });
    return enqueue(function () {
      return request(routes.update, { method: 'POST', body: JSON.stringify(body), headers: JSON_HEADERS }).then(function (res) { return commit(res, opts); });
    });
  };
  cart.refresh = function () {
    return enqueue(function () {
      return request(routes.cart + '?sections=' + encodeURIComponent(sectionsParam()), { cache: 'no-store' })
        .then(function (sections) { return commit({ sections: sections }); });
    });
  };
  cart.open = function (from) {
    var d = drawerEl();
    if (cart.type === 'drawer' && d) { d.open(from); return; }
    window.location.href = routes.cart;
  };
  cart.close = function () { var d = drawerEl(); if (d) d.close(); };
  cart.announce = function (msg) {
    var v = drawerEl() || pageEl(), live = v && qs('[data-fz-live]', v);
    if (!live) {
      live = qs('[data-fz-live-global]');
      if (!live) { live = document.createElement('div'); live.className = 'fz-sr'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); live.setAttribute('data-fz-live-global', ''); document.body.appendChild(live); }
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 40);
  };

  /* ---------- Lien panier de l'en-tête ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-fz-cart-toggle]');
    if (!a) return;
    if (cart.type !== 'drawer' || !drawerEl()) return;
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    cart.open(a);
  });

  /* ---------- Formulaire d'ajout de la fiche produit ---------- */
  function formError(form, msg) {
    var box = qs('[data-fz-form-error]', form);
    if (!box) {
      box = document.createElement('div'); box.className = 'fz-error'; box.setAttribute('data-fz-form-error', ''); box.setAttribute('role', 'alert');
      form.appendChild(box);
    }
    box.textContent = msg || ''; box.hidden = !msg;
  }
  function setFormBusy(form, on) {
    var btn = qs('[data-fz-atc]', form);
    form.__fzBusy = on;
    if (on) form.setAttribute('aria-busy', 'true'); else form.removeAttribute('aria-busy');
    if (btn) { if (on) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('is-loading'); } else { btn.removeAttribute('aria-disabled'); btn.classList.remove('is-loading'); } }
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-fz-product-form]')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    if (form.__fzBusy) return;
    var data = new FormData(form), vid = String(data.get('id') || ''), qty = Math.max(1, Number(data.get('quantity')) || 1);
    ['form_type', 'utf8'].forEach(function (k) { data.delete(k); });
    formError(form, ''); setFormBusy(form, true);
    var opener = document.activeElement;
    cart.add(data).then(function () {
      setFormBusy(form, false);
      var d = drawerEl();
      if (cart.type === 'drawer' && cart.openOnAdd && d) {
        d.afterAdd(vid, qty, opener && opener !== document.body ? opener : qs('[data-fz-atc]', form));
      } else {
        window.location.href = routes.cart;
      }
    }).catch(function (err) {
      setFormBusy(form, false);
      formError(form, cart.errorMessage(err));
    });
  });

  /* ---------- Estimation de livraison (dates) ---------- */
  function addBiz(d, n) { var x = new Date(d.getTime()); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; }
  function updateEta(root) {
    qsa('[data-fz-eta]', root).forEach(function (el) {
      try {
        var mn = Number(el.getAttribute('data-eta-min')), mx = Number(el.getAttribute('data-eta-max'));
        if (!mn || !mx) return;
        var lang = document.documentElement.lang || 'fr', now = new Date(), a = addBiz(now, mn), b = addBiz(now, mx);
        var d1 = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric' });
        var d2 = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'long' });
        var s1 = a.getMonth() === b.getMonth() ? d1.format(a) : d2.format(a);
        el.textContent = 'Livraison estimée entre le ' + s1 + ' et le ' + d2.format(b) +
          (el.getAttribute('data-eta-mode') === 'long' ? ' (jours ouvrés, hors jours fériés).' : '.');
      } catch (err) { /* le texte de base reste affiché */ }
    });
  }

  /* ---------- Briques communes au tiroir et à la page ---------- */
  function swapRegions(host, src) {
    qsa('[data-fz-region]', host).forEach(function (cur) {
      var nxt = qs('[data-fz-region="' + cur.getAttribute('data-fz-region') + '"]', src);
      if (!nxt) return;
      cur.hidden = nxt.hidden;
      Array.prototype.forEach.call(nxt.attributes, function (a) { if (a.name.indexOf('data-') === 0) cur.setAttribute(a.name, a.value); });
      cur.innerHTML = nxt.innerHTML;
    });
  }
  function focusInfo(root) {
    var a = document.activeElement;
    if (!a || a === document.body || !root.contains(a)) return null;
    var line = a.closest('[data-fz-line]');
    if (!line) return null;
    var act = a.getAttribute('data-fz-act') || (a.hasAttribute('data-fz-qty') ? 'qty' : null);
    return act ? { key: line.getAttribute('data-key'), variant: line.getAttribute('data-variant'), act: act } : null;
  }
  function restoreFocus(root, f) {
    if (!f) return;
    var lines = qsa('[data-fz-line]', root), line = null;
    lines.forEach(function (l) { if (!line && (l.getAttribute('data-key') === f.key || (f.variant && l.getAttribute('data-variant') === f.variant))) line = l; });
    if (!line) return;
    var el = qs(f.act === 'qty' ? '[data-fz-qty]' : '[data-fz-act="' + f.act + '"]', line);
    if (el && el.disabled) el = qs('[data-fz-qty]', line);
    if (el) el.focus({ preventScroll: true });
  }
  function readJson(el, attr) { try { return JSON.parse(el.getAttribute(attr) || 'null'); } catch (e) { return null; } }

  class FzCartBase extends HTMLElement {
    connectedCallback() {
      if (!this._bound) { this._bound = true; this.timers = {}; this._bind(); }
      if (this.connected) this.connected();
      updateEta(this);
    }
    disconnectedCallback() { if (this.disconnected) this.disconnected(); }
    _bind() {
      var self = this;
      this.addEventListener('click', function (e) { self.onClick(e); });
      this.addEventListener('change', function (e) { self.onChange(e); });
      this.addEventListener('keydown', function (e) { self.onKey(e); });
    }
    lines() { return qsa('[data-fz-line]', this); }
    lineOf(el) { return el.closest('[data-fz-line]'); }
    lineBy(attr, val) { return this.lines().filter(function (l) { return l.getAttribute(attr) === String(val); })[0] || null; }
    count() { var b = qs('[data-fz-count]', this); return b ? Number(b.getAttribute('data-fz-count')) || 0 : 0; }
    total() { var b = qs('[data-fz-total]', this); return b ? b.getAttribute('data-fz-total') || '' : ''; }
    say(msg) { cart.announce(msg); }
    onClick(e) {
      var t = e.target.closest('[data-fz-act]');
      if (!t || !this.contains(t)) return;
      var act = t.getAttribute('data-fz-act');
      if (act === 'inc' || act === 'dec') { e.preventDefault(); this.step(t, act === 'inc' ? 1 : -1); }
      else if (act === 'rm') { e.preventDefault(); this.removeLine(this.lineOf(t)); }
      else if (act === 'undo') { e.preventDefault(); this.undo(); }
      else if (act === 'quick') { e.preventDefault(); if (!t.disabled) this.quickAdd(t); }
      else if (this.onAct) this.onAct(act, t, e);
    }
    onChange(e) {
      var t = e.target;
      if (!t.matches) return;
      if (t.matches('select[data-fz-act="variant"]')) this.changeVariant(t);
      else if (t.matches('[data-fz-qty]')) this.typedQty(t);
      else if (this.onOtherChange) this.onOtherChange(e);
    }
    onKey(e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-fz-qty]')) { e.preventDefault(); this.typedQty(e.target); }
    }
    setBusy(on) { var b = qs('[data-fz-region="body"]', this) || this; b.setAttribute('aria-busy', on ? 'true' : 'false'); }

    /* Quantités : mise à jour immédiate de l'affichage, envoi groupé pour les clics rapprochés */
    maxOf(input) { var m = Number(input.getAttribute('max')); return m > 0 ? m : cart.maxQty; }
    step(btn, d) {
      var line = this.lineOf(btn), input = line && qs('[data-fz-qty]', line);
      if (input) this.setQty(line, (Number(input.value) || 0) + d, false);
    }
    typedQty(input) {
      var line = this.lineOf(input), v = Math.floor(Number(input.value));
      if (!line) return;
      if (isNaN(v) || v < 0 || input.value === '') v = Number(line.getAttribute('data-qty')) || 1;
      this.setQty(line, v, true);
    }
    setQty(line, q, immediate) {
      var input = qs('[data-fz-qty]', line), key = line.getAttribute('data-key'), max = this.maxOf(input), self = this;
      if (q <= 0) { this.removeLine(line); return; }
      if (q > max) { q = max; this.notice('Quantité maximale pour cet article : ' + max + '.'); }
      input.value = q;
      var dec = qs('[data-fz-act="dec"]', line), inc = qs('[data-fz-act="inc"]', line);
      if (dec) dec.disabled = q <= 1;
      if (inc) inc.disabled = q >= max;
      if (q === Number(line.getAttribute('data-qty'))) return;
      line.setAttribute('data-qty', String(q));
      clearTimeout(this.timers[key]);
      this.timers[key] = setTimeout(function () { self.applyQty(key, q); }, immediate ? 0 : 280);
    }
    applyQty(key, q) {
      var self = this;
      cart.change({ id: key, quantity: q }).then(function () {
        var l = self.lineBy('data-key', key);
        if (l) self.say(l.getAttribute('data-title') + ' : quantité ' + l.getAttribute('data-qty') + '. Total estimé ' + self.total() + '.');
      }).catch(function (err) { self.fail(err); });
    }
    fail(err) {
      this.notice(cart.errorMessage(err), true);
      cart.refresh().catch(function () {});
    }

    /* Retrait d'une ligne, avec annulation possible */
    removeLine(line) {
      if (!line) return;
      var key = line.getAttribute('data-key'), self = this;
      clearTimeout(this.timers[key]);
      this.finalizeRemoval(false);
      this.removed = {
        index: this.lines().indexOf(line), variant: line.getAttribute('data-variant'), qty: Number(line.getAttribute('data-qty')) || 1,
        title: line.getAttribute('data-title') || '', vtitle: line.getAttribute('data-vtitle') || '',
        props: readJson(line, 'data-props'), plan: line.getAttribute('data-plan') || ''
      };
      cart.change({ id: key, quantity: 0 }).then(function () { self.showUndo(); })
        .catch(function (err) { self.removed = null; self.fail(err); });
    }
    undo() {
      var r = this.removed, self = this;
      if (!r) return;
      this.removed = null; clearTimeout(this.rmTimer); this.dropUndo();
      var data = { id: r.variant, quantity: r.qty };
      if (r.props) data.properties = r.props;
      if (r.plan) data.selling_plan = r.plan;
      cart.add(data).then(function () {
        var l = self.lineBy('data-variant', r.variant), b = l && qs('[data-fz-act="rm"]', l);
        if (b) b.focus({ preventScroll: true });
        self.say(r.title + ' remis dans le panier.');
      }).catch(function (err) { self.fail(err); });
    }

    /* Changement de taille : on ajoute la nouvelle variante, puis on retire l'ancienne */
    changeVariant(sel) {
      var line = this.lineOf(sel), self = this;
      if (!line) return;
      var key = line.getAttribute('data-key'), oldV = line.getAttribute('data-variant'), newV = sel.value;
      if (newV === oldV) return;
      var data = { id: newV, quantity: Number(line.getAttribute('data-qty')) || 1 }, props = readJson(line, 'data-props'), plan = line.getAttribute('data-plan');
      if (props) data.properties = props;
      if (plan) data.selling_plan = plan;
      clearTimeout(this.timers[key]);
      this._focusKeep = { key: '', variant: newV, act: 'variant' };
      cart.add(data, { silent: true }).then(function () { return cart.change({ id: key, quantity: 0 }); }).then(function () {
        var l = self.lineBy('data-variant', newV);
        if (l) self.say(l.getAttribute('data-title') + ' : taille ' + l.getAttribute('data-vtitle') + '.');
      }).catch(function (err) {
        self._focusKeep = null; sel.value = oldV; self.notice(cart.errorMessage(err), true);
      });
    }
    quickAdd(btn) {
      var vid = btn.getAttribute('data-variant'), self = this;
      cart.add({ id: vid, quantity: 1 }).then(function () { self.afterAdd(vid, 1); })
        .catch(function (err) { self.notice(cart.errorMessage(err), true); });
    }
    mark(line) {
      line.classList.add('is-new');
      setTimeout(function () { line.classList.remove('is-new'); }, 2000);
    }
    announceAdded(line) {
      var n = this.count();
      this.say(line.getAttribute('data-title') + ' (' + line.getAttribute('data-vtitle') + ') ajouté au panier. ' + plural(n, 'article', 'articles') + ', total estimé ' + this.total() + '.');
    }
  }

  /* ---------- Tiroir panier ---------- */
  class FzCartDrawer extends FzCartBase {
    connected() {
      var self = this;
      this.root = qs('[data-fz-cd-root]', this);
      this.panel = qs('[data-fz-cd-panel]', this);
      this.toastEl = qs('[data-fz-toast]', this);
      this.isOpen = false;
      this._onKey = function (e) { self.onDocKey(e); };
      document.addEventListener('keydown', this._onKey);
      if (!this._swipe) { this._swipe = true; this.bindSwipe(); }
      qsa('[data-fz-cart-toggle]').forEach(function (a) { a.setAttribute('aria-haspopup', 'dialog'); });
      if (cart.__editorOpen) {
        this.root.classList.add('no-anim'); this.open();
        requestAnimationFrame(function () { requestAnimationFrame(function () { self.root.classList.remove('no-anim'); }); });
      }
    }
    disconnected() {
      document.removeEventListener('keydown', this._onKey);
      if (this.isOpen) { this.setInert(false); this.lockScroll(false); this.isOpen = false; }
      clearTimeout(this.rmTimer); clearTimeout(this.toastTimer);
    }
    onAct(act, t, e) { if (act === 'close') { e.preventDefault(); this.close(); } }

    open(from) {
      if (this.isOpen) return;
      this.isOpen = true;
      this.opener = from || document.activeElement;
      this.root.classList.add('is-open');
      this.setInert(true); this.lockScroll(true);
      this.panel.focus({ preventScroll: true });
      updateEta(this);
    }
    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.root.classList.remove('is-open');
      this.setInert(false); this.lockScroll(false);
      this.toastEl.hidden = true;
      this.finalizeRemoval(false);
      var t = this.opener && document.contains(this.opener) ? this.opener : qs('[data-fz-cart-toggle]');
      if (t && t.focus) t.focus({ preventScroll: true });
      this.opener = null;
    }
    /* Le reste de la page ne reçoit plus ni focus ni clics tant que le tiroir est ouvert */
    setInert(on) {
      var self = this;
      if (on) {
        this._inerted = [];
        Array.prototype.forEach.call(document.body.children, function (c) {
          if (/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(c.tagName) || c.contains(self) || c.hasAttribute('inert')) return;
          c.setAttribute('inert', ''); self._inerted.push(c);
        });
      } else {
        (this._inerted || []).forEach(function (c) { c.removeAttribute('inert'); });
        this._inerted = [];
      }
    }
    lockScroll(on) {
      var de = document.documentElement;
      if (on) {
        var sb = window.innerWidth - de.clientWidth;
        this._pad = de.style.paddingRight;
        if (sb > 0) de.style.paddingRight = sb + 'px';
        de.style.overflow = 'hidden';
      } else { de.style.overflow = ''; de.style.paddingRight = this._pad || ''; }
    }
    onDocKey(e) {
      if (!this.isOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); this.close(); return; }
      if (e.key !== 'Tab') return;
      var f = qsa('a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),[tabindex]:not([tabindex="-1"])', this.panel)
        .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
      if (!f.length) { e.preventDefault(); this.panel.focus(); return; }
      var first = f[0], last = f[f.length - 1], a = document.activeElement, out = a === this.panel || !this.panel.contains(a);
      if (e.shiftKey && (a === first || out)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || out)) { e.preventDefault(); first.focus(); }
    }
    /* Glisser vers la droite pour fermer (mobile) */
    bindSwipe() {
      var self = this, sx = 0, sy = 0, on = false;
      this.panel.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; on = !e.target.closest('select, input, textarea'); sx = t.clientX; sy = t.clientY;
      }, { passive: true });
      this.panel.addEventListener('touchend', function (e) {
        if (!on) return;
        var t = e.changedTouches[0];
        if (t.clientX - sx > 90 && Math.abs(t.clientY - sy) < 50) self.close();
      }, { passive: true });
    }

    /* Remplace les zones du tiroir par celles de la section renvoyée par le serveur */
    renderHtml(html) {
      var doc = parseHtml(html), src = qs('fz-cart-drawer', doc) || doc.body;
      var f = this._focusKeep || focusInfo(this);
      this._focusKeep = null;
      swapRegions(this, src);
      this.injectUndo();
      restoreFocus(this, f);
      if (FZ.refresh) FZ.refresh(this);
    }
    syncEmpty() {
      var ul = qs('[data-fz-lines]', this), empty = qs('[data-fz-empty]', this);
      if (!ul || !empty) return;
      var has = this.lines().length > 0 || !!qs('[data-fz-undo]', this);
      ul.hidden = !has; empty.hidden = has;
    }
    injectUndo() {
      var r = this.removed, ul = qs('[data-fz-lines]', this);
      qsa('[data-fz-undo]', this).forEach(function (u) { u.remove(); });
      if (r && ul) {
        var li = document.createElement('li');
        li.className = 'fz-cd__undo'; li.setAttribute('data-fz-undo', '');
        var sp = document.createElement('span'); sp.textContent = r.title + ' (' + r.vtitle + ') retiré.';
        var b = document.createElement('button'); b.type = 'button'; b.className = 'fz-cd__undo-b'; b.setAttribute('data-fz-act', 'undo'); b.textContent = 'Annuler';
        li.appendChild(sp); li.appendChild(b);
        var ref = this.lines()[r.index] || null;
        ul.insertBefore(li, ref);
      }
      this.syncEmpty();
    }
    showUndo() {
      var self = this, b = qs('[data-fz-undo] [data-fz-act="undo"]', this);
      this.injectUndo();
      b = qs('[data-fz-undo] [data-fz-act="undo"]', this);
      if (b) b.focus({ preventScroll: true });
      if (this.removed) this.say(this.removed.title + ' (' + this.removed.vtitle + ') retiré du panier. Bouton annuler disponible.');
      clearTimeout(this.rmTimer);
      this.rmTimer = setTimeout(function () { self.finalizeRemoval(true); }, 6500);
    }
    dropUndo() { qsa('[data-fz-undo]', this).forEach(function (u) { u.remove(); }); this.syncEmpty(); }
    finalizeRemoval(moveFocus) {
      var u = qs('[data-fz-undo]', this);
      if (!this.removed && !u) return;
      var at = this.removed ? this.removed.index : 0, had = u && u.contains(document.activeElement);
      clearTimeout(this.rmTimer); this.removed = null;
      if (u) u.remove();
      this.syncEmpty();
      if (had && moveFocus !== false) {
        var rms = qsa('[data-fz-line] [data-fz-act="rm"]', this), t = rms[Math.min(at, rms.length - 1)];
        if (t) t.focus({ preventScroll: true }); else { var h = qs('#fz-cd-empty-h', this); if (h) h.focus({ preventScroll: true }); }
      }
    }
    notice(msg) {
      var el = this.toastEl, self = this;
      if (!el) return;
      clearTimeout(this.toastTimer);
      el.hidden = false; el.textContent = '';
      setTimeout(function () { el.textContent = msg; }, 30);
      this.toastTimer = setTimeout(function () { el.hidden = true; }, 6000);
    }
    afterAdd(vid, qty, opener) {
      if (!this.isOpen) this.open(opener);
      var line = this.lineBy('data-variant', vid), body = qs('[data-fz-region="body"]', this);
      if (!line) return;
      this.mark(line);
      if (body) body.scrollTo({ top: Math.max(0, line.offsetTop - 14), behavior: reduced() ? 'auto' : 'smooth' });
      line.focus({ preventScroll: true });
      this.announceAdded(line);
    }
  }
  if (!customElements.get('fz-cart-drawer')) customElements.define('fz-cart-drawer', FzCartDrawer);

  /* ---------- Éditeur de thème : le tiroir s'ouvre quand on sélectionne la section ---------- */
  document.addEventListener('shopify:section:select', function (e) {
    var d = e.target && e.target.querySelector && e.target.querySelector('fz-cart-drawer');
    if (d) { cart.__editorOpen = true; d.open(); }
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var d = e.target && e.target.querySelector && e.target.querySelector('fz-cart-drawer');
    if (d) { cart.__editorOpen = false; d.close(); }
  });

  /* ---------- Page Panier ---------- */
  class FzCartPage extends FzCartBase {
    connected() {
      var self = this;
      this.toastEl = qs('[data-fz-toast]', this);
      this._bar = function () { self.barUpdate(); };
      window.addEventListener('scroll', this._bar, { passive: true });
      window.addEventListener('resize', this._bar);
      if (!this._inp) {
        this._inp = true;
        this.addEventListener('input', function (e) {
          var t = e.target;
          if (t && t.matches && t.matches('[data-fz-note]')) {
            var c = qs('[data-fz-note-count]', self);
            if (c) c.textContent = t.value.length + ' / ' + (t.getAttribute('maxlength') || 300);
          }
        });
      }
      this.barUpdate();
    }
    disconnected() {
      window.removeEventListener('scroll', this._bar);
      window.removeEventListener('resize', this._bar);
      clearTimeout(this.rmTimer); clearTimeout(this.toastTimer);
    }
    setBusy(on) { var m = qs('[data-fz-pc-main]', this); if (m) m.setAttribute('aria-busy', on ? 'true' : 'false'); }

    /* Recharge la page (section) renvoyée par le serveur et remplace les zones qui ont changé */
    refresh() {
      var self = this, id = this.getAttribute('data-section-id'), base = routes.cart + (routes.cart.indexOf('?') < 0 ? '?' : '&');
      function load(url) {
        return fetch(url, { cache: 'no-store', credentials: 'same-origin', headers: { 'Accept': 'text/html', 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (res) { if (!res.ok) { var e = new Error('cart'); e.status = res.status; throw e; } return res.text(); })
          .then(function (html) { return qs('fz-cart-page', parseHtml(html)); });
      }
      /* D'abord la seule section (léger) ; à défaut, la page entière */
      var first = id ? load(base + 'section_id=' + encodeURIComponent(id) + '&_=' + Date.now()).catch(function () { return null; }) : Promise.resolve(null);
      return first.then(function (src) { return src || load(base + '_=' + Date.now()); }).then(function (src) {
        if (!src) { var e = new Error('cart'); e.status = 500; throw e; }
        var f = self._focusKeep || focusInfo(self);
        self._focusKeep = null;
        var cur = qs('[data-fz-pc-main]', self), nxt = qs('[data-fz-pc-main]', src);
        if (cur && nxt && cur.getAttribute('data-fz-state') !== nxt.getAttribute('data-fz-state')) {
          cur.innerHTML = nxt.innerHTML; cur.setAttribute('data-fz-state', nxt.getAttribute('data-fz-state'));
        }
        swapRegions(self, src);
        restoreFocus(self, f);
        updateEta(self);
        self.barUpdate();
        if (FZ.refresh) FZ.refresh(self);
      });
    }

    /* Suggestions « La cordée » : choix de la taille, puis ajout */
    onAct(act, t, e) {
      var card = t.closest('[data-fz-card]'), self = this;
      if (!card) return;
      if (act === 'pick') {
        e.preventDefault();
        if (t.disabled) return;
        qsa('[data-fz-act="pick"]', card).forEach(function (c) { c.setAttribute('aria-pressed', c === t ? 'true' : 'false'); });
        card.setAttribute('data-variant', t.getAttribute('data-variant'));
        var chips = qs('.fz-pc__chips', card), add = qs('[data-fz-act="add"]', card);
        if (chips) chips.classList.remove('is-need');
        if (add) {
          add.removeAttribute('aria-disabled');
          add.textContent = (card.getAttribute('data-add-label') || 'Ajouter') + ' · ' + (card.getAttribute('data-price') || '');
        }
      } else if (act === 'add') {
        e.preventDefault();
        var vid = card.getAttribute('data-variant');
        if (t.getAttribute('aria-disabled') === 'true' || !vid) {
          var cs = qs('.fz-pc__chips', card), first = qs('.fz-pc__chip:not(:disabled)', card);
          if (cs) cs.classList.add('is-need');
          if (first) first.focus();
          this.say('Choisissez d\'abord une taille.');
          return;
        }
        if (t.getAttribute('aria-busy') === 'true') return;
        t.setAttribute('aria-busy', 'true');
        cart.add({ id: vid, quantity: 1 }).then(function () { self.afterAdd(vid); })
          .catch(function (err) { t.removeAttribute('aria-busy'); self.notice(cart.errorMessage(err), true); });
      }
    }
    /* Note de commande : enregistrée dès qu'on quitte le champ */
    onOtherChange(e) {
      var t = e.target, self = this;
      if (t.matches && t.matches('[data-fz-note]')) {
        cart.update({ note: t.value }, { silent: true }).catch(function (err) { self.notice(cart.errorMessage(err), true); });
      }
    }

    /* Message flottant (confirmation brève ou erreur) */
    showToast(build, isErr, ms) {
      var el = this.toastEl;
      if (!el) return;
      clearTimeout(this.toastTimer);
      el.textContent = '';
      el.setAttribute('aria-live', isErr ? 'off' : 'polite');
      build(el);
      el.hidden = false;
      if (ms) this.toastTimer = setTimeout(function () { el.hidden = true; }, ms);
    }
    notice(msg, isErr) {
      if (this.removed) this.finalizeRemoval(false);
      this.showToast(function (el) {
        var s = document.createElement('span'); s.className = 'fz-pc__toast-m';
        if (isErr) s.setAttribute('role', 'alert');
        el.appendChild(s);
        setTimeout(function () { s.textContent = msg; }, 30);
      }, isErr, isErr ? 6000 : 3600);
    }
    showUndo() {
      var self = this, r = this.removed;
      if (!r) return;
      this.showToast(function (el) {
        var s = document.createElement('span'); s.className = 'fz-pc__toast-m'; s.textContent = r.title + ' (' + r.vtitle + ') retiré.';
        var b = document.createElement('button'); b.type = 'button'; b.className = 'fz-pc__undo'; b.setAttribute('data-fz-act', 'undo'); b.textContent = 'Annuler';
        el.appendChild(s); el.appendChild(b);
      }, false, 0);
      var u = qs('.fz-pc__undo', this.toastEl);
      if (u) u.focus({ preventScroll: true });
      this.say(r.title + ' (' + r.vtitle + ') retiré du panier. Bouton annuler disponible.');
      clearTimeout(this.rmTimer);
      this.rmTimer = setTimeout(function () { self.finalizeRemoval(true); }, 7000);
    }
    dropUndo() {
      if (this.toastEl && qs('.fz-pc__undo', this.toastEl)) { clearTimeout(this.toastTimer); this.toastEl.hidden = true; this.toastEl.textContent = ''; }
    }
    finalizeRemoval(moveFocus) {
      var u = this.toastEl && qs('.fz-pc__undo', this.toastEl);
      if (!this.removed && !u) return;
      var at = this.removed ? this.removed.index : 0, had = u && u.contains(document.activeElement);
      clearTimeout(this.rmTimer); this.removed = null;
      this.dropUndo();
      if (had && moveFocus !== false) {
        var rms = qsa('[data-fz-line] [data-fz-act="rm"]', this), t = rms[Math.min(at, rms.length - 1)];
        if (t) t.focus({ preventScroll: true });
        else { var h = qs('#fz-pc-empty-h', this); if (h) h.focus({ preventScroll: true }); }
      }
    }
    afterAdd(vid) {
      var line = this.lineBy('data-variant', vid);
      if (!line) return;
      this.mark(line);
      line.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
      line.focus({ preventScroll: true });
      this.announceAdded(line);
    }
    /* Barre de paiement collée en bas (mobile) : visible tant que le bouton de paiement est sous l'écran */
    barUpdate() {
      var bar = qs('[data-fz-region="bar"]', this), cta = qs('[data-fz-cta]', this);
      if (!bar) return;
      if (!cta || this.count() === 0) { bar.hidden = true; return; }
      bar.hidden = !(cta.getBoundingClientRect().top > window.innerHeight - 24);
    }
  }
  if (!customElements.get('fz-cart-page')) customElements.define('fz-cart-page', FzCartPage);

  /* Sur la page Panier, le lien du panier de l'en-tête ne recharge pas la page */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-fz-cart-toggle]'), p = pageEl();
    if (!a || !p || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    var h = qs('#fz-pc-title', p) || p; if (h.focus) h.focus({ preventScroll: true });
    window.scrollTo({ top: 0, behavior: reduced() ? 'auto' : 'smooth' });
  });

})();
